import bindAllMethods from '../../utils/bindAllMethods';
import IAnalyticsService from './IAnalyticsService';
import CustomAnalyticsService from './strategies/CustomAnalyticsService';
import DefaultAnalyticsService from './strategies/DefaultAnalyticsService';
import { AnalyticsServiceInputType } from './types';
import { InternalService } from '../../core/services';

export * from './analyticsServiceConstants';

export default class AnalyticsService
  extends InternalService
  implements IAnalyticsService
{
  private _analyticsService: IAnalyticsService;

  constructor(analyticsProps: AnalyticsServiceInputType) {
    super();
    if (analyticsProps?.customAnalyticsSubsystem?.eventName) {
      this._analyticsService = new CustomAnalyticsService(analyticsProps);
    } else {
      this._analyticsService = new DefaultAnalyticsService(analyticsProps);
    }

    bindAllMethods(this);
  }

  public setDependencies(
    ...args: Parameters<IAnalyticsService['setDependencies']>
  ): void {
    this._analyticsService.setDependencies(...args);
  }

  public isEnabled(): boolean {
    return this._analyticsService.isEnabled();
  }

  public async init(): Promise<void> {
    // Execute initialization commands
    await this._initializeStrategy();

    this._markAsReady();
  }

  /**
   * Command: Initialize the analytics strategy
   */
  private async _initializeStrategy(): Promise<void> {
    await this._analyticsService.init();
  }

  public async publishCdmEvents(
    ...args: Parameters<IAnalyticsService['publishCdmEvents']>
  ): Promise<void> {
    return this._analyticsService.publishCdmEvents(...args);
  }
}
